import { ZzUser } from "src/app/zz/zz-user/shared/zz-user.model";

export interface AppMessage{
  isOK?: boolean;
  message?: string;
  longId?: number;
  errorType?: number;
}
export interface AppRequestPara{
  curId?: string;
  fromDate?: Date;
  toDate?: Date;
  minRem?: number;
  longId?: number;
  user?: ZzUser;
  parIds?: string[];
  parId?: string;
  padId?: string;
  macId?: string;
  stoIdIn?: string;
  stoIdOut?: string;
}
export interface AppReportRequestPara{
  id?: number;
  pdfId?: string;
  isCT?: boolean; //Giá theo chứng từ
  isConfirmed?: boolean;
}
export enum AppErrorTypeEN
{
    NotPermission = 0,
    UnAuthorized = 1,
    Orther = 9

}
